import {
  Box,
  Icon,
  Text,
  type IconName,
} from "@salestrak/ui";

// Every section on this page is one header over its content on ONE rhythm: a
// muted 20px glyph beside the 18px title, then 24px of air. It lives here once
// so no section can hold its own copy of that pair and drift off it — a
// section header rendered inline at page level picks up the PAGE gap, not this
// one. The 32px page gap either side of the rules between sections is what
// reads as the section break.
export function PermissionsSection({
  icon,
  title,
  children,
}: {
  icon: IconName;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <Box gap="lg">
      <Box direction="row" align="center" gap="sm">
        <Icon name={icon} size="lg" color="muted" />
        <Text size="lg" weight="semibold">
          {title}
        </Text>
      </Box>
      {children}
    </Box>
  );
}
